import { AppRoute } from './routes'

export const pageTitles: Record<AppRoute, string> = {
  [AppRoute.Login]: 'Login',
  [AppRoute.Home]: 'Homepage',
  [AppRoute.HomeMath]: 'Homepage - Math',
  [AppRoute.HomeEla]: 'Homepage - ELA',
  [AppRoute.AssessmentMath]: 'Math assessment',
  [AppRoute.AssessmentEla]: 'ELA assessment',
  [AppRoute.AssessmentResultsMath]: 'Math assessment result',
  [AppRoute.AssessmentResultsEla]: 'ELA assessment result',
  [AppRoute.AssessmentCatchUpResultsMath]: 'Math catch-up assessment result',
  [AppRoute.AssessmentCatchUpResultsEla]: 'ELA catch-up assessment result',
  [AppRoute.SummarizeMath]: 'AI-Summarize Math',
  [AppRoute.SummarizeEla]: 'AI-Summarize ELA',
  [AppRoute.Files]: 'Learning files - Math',
  [AppRoute.FilesEla]: 'Learning files - ELA',
  [AppRoute.Feedback]: 'Lesson feedback',
  [AppRoute.Lessons]: 'All lessons - Math',
  [AppRoute.LessonsEla]: 'All lessons - ELA',
  [AppRoute.LearningProgress]: 'Learning progress - Math',
  [AppRoute.LearningProgressEla]: 'Learning progress - ELA',
  [AppRoute.LearningProgressGoals]: 'Goals - Math',
  [AppRoute.LearningProgressGoalsEla]: 'Goals - ELA',
  [AppRoute.LearningPlan]: 'Learning plan - Math',
  [AppRoute.LearningPlanEla]: 'Learning plan - ELA',
  [AppRoute.LearningPlanUnits]: 'Learning plan units - Math',
  [AppRoute.LearningPlanUnitsEla]: 'Learning plan units - ELA',
  [AppRoute.LearningPlanUnit]: 'Learning plan unit - Math',
  [AppRoute.LearningPlanUnitEla]: 'Learning plan unit - ELA',
  [AppRoute.LessonRoom]: 'Lesson room - Math',
  [AppRoute.LessonRoomEla]: 'Lesson room - ELA',
  [AppRoute.Schedule]: 'Change weekly schedule - Math',
  [AppRoute.ScheduleEla]: 'Change weekly schedule - ELA',
  [AppRoute.SkillReport]: 'Skill report - Math',
  [AppRoute.SkillReportEla]: 'Skill report - ELA',
  [AppRoute.ProgressReports]: 'Progress reports - Math',
  [AppRoute.ProgressReportsEla]: 'Progress reports - ELA',
  [AppRoute.ProgressReport]: 'Progress report - Math',
  [AppRoute.ProgressReportEla]: 'Progress report - ELA',
  [AppRoute.MasteryMaps]: 'Mastery maps - Math',
  [AppRoute.MasteryMapsEla]: 'Mastery maps - ELA',
  [AppRoute.LearningProgressAssessments]: 'Assessments - Math',
  [AppRoute.LearningProgressAssessmentsEla]: 'Assessments - ELA',
  [AppRoute.LearningProgressAssessment]: 'Assessment results - Math',
  [AppRoute.LearningProgressAssessmentEla]: 'Assessment results - ELA',
  [AppRoute.PadMath]: 'Prices page - Math',
  [AppRoute.PadEla]: 'Prices page - ELA',
  [AppRoute.PricingMath]: 'Prices page - Math',
  [AppRoute.PricingEla]: 'Prices page - ELA',
  [AppRoute.HelpCenter]: 'Help center',
  [AppRoute.Payments]: 'Payments',
  [AppRoute.PaymentsMethods]: 'Payments methods',
  [AppRoute.PaymentsHistory]: 'Payments history',
  [AppRoute.PaymentsSubscriptions]: 'Payments subscriptions',
  [AppRoute.Profile]: 'Profile',
  [AppRoute.Order]: 'Order payment',
  [AppRoute.Checkout]: 'Checkout',
  [AppRoute.Upsell]: 'Special offer',
  [AppRoute.UpsellBooking]: 'Book a free demo',
  [AppRoute.UpsellPlan]: 'Your second subject',
  [AppRoute.Referral]: 'Referral',
  [AppRoute.FeedbackThankYou]: 'Thank you for your feedback',
}
